import { useGetDuplicationSourceSeasonsQuery } from '@modules/yoy/api/yoyApi';
import useCurrentSeasonId from '@modules/encoding/shared/hooks/useCurrentSeasonId';

export const useDuplicationSeasonSource = () => {
    const { currentSeasonId } = useCurrentSeasonId();
    const { data: farmSeasons } = useGetDuplicationSourceSeasonsQuery({ farmSeasonId: currentSeasonId });

    return { farmSeasons };
};
